import PropTypes from "prop-types";
import "./MediaArticles.scss";
import { merchandisingMediaShape, resolutionPropType } from "app/utils/propTypes";
import get from "lodash/get";
import IconCrossDark from "app/pages/.shared/static/icons/IconCrossDark";
import MediaArticleItem from "app/pages/Merchandising/Media/MediaArticleItem";
import Button from "app/pages/.shared/form/Button";
import { FormattedMessage } from "react-intl";
import IconBack from "app/pages/.shared/static/icons/IconBack";

const MediaArticles = ({ mediaList = [], title, onClose, resolution }) => {
	return (
		<div className="media-articles">
			<header className="media-articles__header">
				{title}
				<div className="media-articles__close" onClick={onClose}>
					<IconCrossDark height={20} width={20} />
				</div>
			</header>
			<div className="media-articles__list">
				{mediaList.map(media => {
					return (
						<div key={media.title} className="media-articles__article">
							<MediaArticleItem
								photoUrl={media.image}
								title={media.title}
								photoThumbnail={media.thumbnail}
								descriptions={media.description}
								videoType={get(media, "video.videoType")}
								videoUrl={get(media, "video.url")}
								videoPreviewUrl={get(media, "video.previewUrl")}
								videoThumbnail={get(media, "video.thumbnail")}
								author={media.copyright}
								resolution={resolution}
							/>
						</div>
					);
				})}
			</div>
			<div className="media-articles__cta">
				<Button submit={false} onClick={onClose}>
					<IconBack height={10} width={10} style={{ marginRight: 10 }} />
					<FormattedMessage id="merchandising.media.cta.back.text" />
				</Button>
			</div>
		</div>
	);
};

MediaArticles.propTypes = {
	title: PropTypes.string,
	onClose: PropTypes.func,
	mediaList: PropTypes.arrayOf(merchandisingMediaShape),
	resolution: resolutionPropType,
};

export default MediaArticles;
